module.exports = __webpack_public_path__ + "static/media/comm_slack.39440503.png";